import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
function PeethaDetail({ peethas }) {
  const { slug } = useParams();

  useEffect(() => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "instant",
  });
}, [slug]);

const peetha = peethas.find(
  (item) => item.slug === slug
);

if (!peetha) {
  return (
    <p className="text-center text-red-500">
      Peetha not found
    </p>
  );
}

const pageTitle = `${peetha.name} | ${peetha.location.state} | Shakti Pravaah`;

const pageDescription =
  peetha.description.length > 160
    ? peetha.description.slice(0, 157) + "..."
    : peetha.description;

const pageUrl = `https://shaktipeethsthan.com/peetha/${slug}`;
const imageUrl = `https://shaktipeethsthan.com${peetha.image}`;

const faqs = [
  {
    question: `Which part of Goddess Sati fell at ${peetha.name}?`,
    answer: `According to Shakti Peeth tradition, the ${peetha.part} of Goddess Sati fell at this sacred site, making ${peetha.name} one of the revered Shakti Peethas of Bharat.`,
  },
  {
    question: `Where is ${peetha.name} located?`,
    answer: `${peetha.name} is located in ${peetha.location.city}, ${peetha.location.state}, ${peetha.location.country}.`,
  },
  peetha.culturalHeritage?.bestVisit && {
    question: `What is the best time to visit ${peetha.name}?`,
    answer: `The best time to visit ${peetha.name} is during the ${peetha.culturalHeritage.bestVisit.season} (${peetha.culturalHeritage.bestVisit.months}).`,
  },
  peetha.travel && {
    question: `How can I reach ${peetha.name}?`,
    answer: `The nearest airport to ${peetha.name} is ${peetha.travel.nearestAirport}, and the nearest railway station is ${peetha.travel.nearestRailway}.`,
  },
  peetha.culturalHeritage?.attractions?.length && {
    question: `What are the nearby attractions near ${peetha.name}?`,
    answer: `Popular nearby attractions near ${peetha.name} include ${peetha.culturalHeritage.attractions.join(", ")}.`,
  },
].filter(Boolean);

const sameState = peethas.filter(
  (p) => p.slug !== peetha.slug && p.location.state === peetha.location.state
);
const sameCountry = peethas.filter(
  (p) =>
    p.slug !== peetha.slug &&
    p.location.country === peetha.location.country &&
    p.location.state !== peetha.location.state
);
const otherCountries = peethas.filter(
  (p) => p.slug !== peetha.slug && p.location.country !== peetha.location.country
);
const relatedPeethas = [...sameState, ...sameCountry, ...otherCountries].slice(0, 4);

  return (

    <>
  <Helmet>
    <title>
{peetha.name} | {peetha.location.state} | Shakti Pravaah
</title>

    <meta
      name="description"
      content={pageDescription}
    />

    <meta
  name="keywords"
  content={`
    ${peetha.name},
    ${peetha.location.state},
    ${peetha.location.country},
    Shakti Peeth,
    Shaktipeeth,
    Hindu Temple,
    Devi Temple,
    ${peetha.part},
    Goddess Sati,
    Shakti Pravaah
  `}
/>

<meta name="robots" content="index, follow" />

<meta name="author" content="Shakti Pravaah" />

<meta property="og:site_name" content="Shakti Pravaah" />

<meta property="og:locale" content="en_IN" />

<meta property="article:section" content="Shakti Peeth" />

    <link
      rel="canonical"
      href={pageUrl}
    />

    {/* Open Graph */}
    <meta property="og:title" content={pageTitle} />
    <meta property="og:description" content={pageDescription} />
    <meta
  property="og:image"
  content={imageUrl}
/>
    <meta
      property="og:url"
      content={pageUrl}
    />
    <meta property="og:type" content="article" />

    {/* Twitter */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={pageTitle} />
    <meta name="twitter:description" content={pageDescription} />
    <meta
  name="twitter:image"
  content={imageUrl}
/>

<script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": ["Place", "TouristAttraction"],
    name: peetha.name,
    image: {
      "@type": "ImageObject",
      url: imageUrl,
    },
    description: peetha.description,
    url: pageUrl,
    address: {
      "@type": "PostalAddress",
      addressLocality: peetha.location.city,
      addressRegion: peetha.location.state,
      addressCountry: peetha.location.country,
    },
  })}
</script>

<script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://shaktipeethsthan.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: peetha.name,
        item: pageUrl,
      },
    ],
  })}
</script>

{faqs.length > 0 && (
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer,
        },
      })),
    })}
  </script>
)}

  </Helmet>
  

  

    <div className="p-6 max-w-3xl mx-auto">
      {/* Breadcrumb */}
      <nav aria-label="Breadcrumb" className="mb-4 text-sm text-gray-500">
        <Link to="/" className="text-orange-500 hover:underline">
          Home
        </Link>
        <span className="mx-2">/</span>
        <span className="text-gray-700">{peetha.name}</span>
      </nav>

      {/* Back link at the top */}
      <div className="mb-4">
        <Link to="/" className="text-orange-500 hover:underline">
          ← Back to Peethas
        </Link>
      </div>

      <img
        src={peetha.image}
        alt={peetha.name}
        className="w-full h-64 object-cover rounded-xl shadow-md"
      />

      <h1 className="text-3xl font-bold text-orange-800 mt-4">
        {peetha.name}
      </h1>

      <p className="text-orange-600 font-semibold mt-2">
        Body Part: {peetha.part}
      </p>

      <p className="text-gray-700 mt-4 leading-relaxed">
        {peetha.significance}
      </p>

      <p className="text-gray-700 mt-4 leading-relaxed">
        {peetha.description}
      </p>

      {peetha.mapLink && (
        <a
          href={peetha.mapLink}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block mt-6 bg-orange-600 text-white px-5 py-2 rounded-lg hover:bg-orange-700 transition"
        >
          View on Map
        </a>
      )}
    
{/* Cultural Heritage */}
{peetha.culturalHeritage && (

  <div className="mt-10">
    <h2 className="text-3xl font-bold text-orange-800 mb-6">
      Cultural Heritage
    </h2>


{/* Food + Attire */}
<div className="grid md:grid-cols-2 gap-6">

  <div className="bg-white p-4 rounded-xl shadow">
    <img
      src={peetha.culturalHeritage.food.image}
      alt="Food"
      className="w-full h-48 object-cover rounded-lg"
    />

    <h3 className="font-bold text-xl mt-4">
      {peetha.culturalHeritage.food.title}
    </h3>

    <p className="text-gray-600 mt-2">
      {peetha.culturalHeritage.food.description}
    </p>
  </div>

  <div className="bg-white p-4 rounded-xl shadow">
    <img
      src={peetha.culturalHeritage.attire.image}
      alt="Attire"
      className="w-full h-48 object-cover rounded-lg"
    />

    <h3 className="font-bold text-xl mt-4">
      {peetha.culturalHeritage.attire.title}
    </h3>

    <p className="text-gray-600 mt-2">
      {peetha.culturalHeritage.attire.description}
    </p>
  </div>

</div>

{/* Attractions + Best Visit */}
<div className="grid md:grid-cols-3 gap-6 mt-6">

  <div className="md:col-span-2 bg-white p-5 rounded-xl shadow">
    <h3 className="font-bold text-xl mb-4">
      Nearby Attractions
    </h3>

    <div className="flex flex-wrap gap-2">
      {peetha.culturalHeritage.attractions?.map(
        (place, index) => (
          <span
            key={index}
            className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm"
          >
            {place}
          </span>
        )
      )}
    </div>
  </div>

  <div className="bg-orange-700 text-white p-5 rounded-xl shadow">
    <h3 className="font-bold text-lg">
      Best Visit
    </h3>

    <p className="mt-4 text-xl font-semibold">
      {peetha.culturalHeritage.bestVisit?.season}
    </p>

    <p className="mt-1">
      {peetha.culturalHeritage.bestVisit?.months}
    </p>
  </div>

</div>

  </div>
)}

{/* Spiritual Reflection */}
{peetha.spiritualReflection && (

  <div className="mt-10 bg-orange-50 p-6 rounded-xl shadow">
    <h2 className="text-2xl font-bold text-orange-800 mb-4">
      Spiritual Reflection
    </h2>

<p className="italic text-gray-700 leading-relaxed">
  "{peetha.spiritualReflection}"
</p>

  </div>
)}
 {/* Travel Access */}
{peetha.travel && (

  <div className="mt-10 bg-orange-50 p-5 rounded-xl shadow">
    <h2 className="text-2xl font-bold text-orange-800 mb-4">
      Travel Access
    </h2>

<div className="space-y-2 text-gray-700">
  <p>
    ✈️ <strong>Nearest Airport:</strong>{" "}
    {peetha.travel.nearestAirport}
  </p>

  <p>
    🚆 <strong>Nearest Railway:</strong>{" "}
    {peetha.travel.nearestRailway}
  </p>
</div>

  </div>
)}

{/* FAQs */}
{faqs.length > 0 && (
  <div className="mt-10">
    <h2 className="text-2xl font-bold text-orange-800 mb-4">
      Frequently Asked Questions
    </h2>

    <div className="space-y-3">
      {faqs.map((faq, index) => (
        <details
          key={index}
          className="bg-white p-4 rounded-xl shadow border border-orange-100"
        >
          <summary className="font-semibold text-orange-700 cursor-pointer">
            {faq.question}
          </summary>
          <p className="text-gray-700 mt-2 leading-relaxed">
            {faq.answer}
          </p>
        </details>
      ))}
    </div>
  </div>
)}

{/* Related Shakti Peeths */}
{relatedPeethas.length > 0 && (
  <div className="mt-10 bg-orange-50 p-6 rounded-xl shadow">
    <h2 className="text-2xl font-bold text-orange-800 mb-4">
      Related Shakti Peeths
    </h2>

    <ul className="grid sm:grid-cols-2 gap-3">
      {relatedPeethas.map((related) => (
        <li key={related.slug}>
          <Link
            to={`/peetha/${related.slug}`}
            className="text-orange-600 hover:underline font-medium"
          >
            {related.name}
          </Link>
        </li>
      ))}
    </ul>
  </div>
)}

    </div>
    </>
  );
}

export default PeethaDetail;
